import axios from '../../../../lib/axios'
import { leavePolicyDetails } from '../../../../lib/apiList'
import {
    UpdateLeavePolicyDetailsRequest,
    DeleteLeavePolicyDetailsRequest,
} from './types'

export const updateLeavePolicyDetails = (
    body: UpdateLeavePolicyDetailsRequest
): Promise<any> => {
    const response = axios.put(
        leavePolicyDetails.UPDATE_LEAVE_POLICY_DETAILS,
        body
    )
    return response
}

export const getLeavePolicyDetails = (id: string): Promise<any> => {
    const url = `${leavePolicyDetails.GET_LEAVE_POLICY_DETAILS}/${id}`
    const response = axios.get(url)
    return response
}

export const deleteLeavePolicyDetails = (
    leavePolicyId: DeleteLeavePolicyDetailsRequest
): Promise<any> => {
    const response = axios.delete(leavePolicyDetails.DELETE_LEAVE_POLICY, {
        data: leavePolicyId,
    })
    return response
}
